<div class="vo-central-content">
    <div class="heading-image mb-30">
      <div class="logo"></div>
    </div>
    <div class="login-extended-functionality-container mx-auto p-30 text-center">
        <div class="vo-heading-bold-24 my-15" [innerHTML]="titleLabel | localizeLabel | toTrustedHtml"></div>
        <div class="vo-body-regular-14 my-30" [innerHTML]="descriptionLabel | localizeLabel | toTrustedHtml"></div>
        <a class="vo-link" (click)="goToLogin()" [innerHTML]="referenceDataLabels.BackToLogin | localizeLabel"></a>
    </div>
  </div>
